import { createFileRoute } from '@tanstack/react-router';
import { PageStub } from '@/components/shared/PageStub';

export const Route = createFileRoute('/operations/compliance')({
  component: () => <PageStub title="Legal & Compliance" description="Compliance management" />,
});
